<div id="rateYo"></div>
<!-- Self Help nav bar -->
<div class="card table-container">
  <div class="card-body" id="kba_card_body">
      <div class="tab-content">
        <div class="tab-pane active" id="zsd-knowledgebase"></div>

        <div class="row">
          <div class="col-12">
            <div class="card" id="kba_card_override">
              <div class="card-body text-center" id="kba_header_card_body">
                <ul class="d-none d-lg-block">
                  <li class="kba_header" [ngClass]="(knowledgebasefilterinfo === null || !knowledgebasefilterinfo.kbaType || knowledgebasefilterinfo.kbaType === null) ? 'kba-header-active' : ''" (click)="onChangeKbaType('all')" > {{ 'KnowledgeBase.all' | translate }}  ({{ kbaResultsCount }})</li> 
                  <li class="kba_header" [ngClass]="(knowledgebasefilterinfo != null && knowledgebasefilterinfo.kbaType === KBA_TYPE_ARTICLE) ? 'kba-header-active' : ''" (click)="onChangeKbaType('article')"> {{ 'KnowledgeBase.article' | translate }} ({{ kbaArticleCount }})</li>
                  <li class="kba_header" [ngClass]="(knowledgebasefilterinfo != null && knowledgebasefilterinfo.kbaType === KBA_TYPE_FAQ) ? 'kba-header-active' : ''" (click)="onChangeKbaType('faqs')"> {{ 'KnowledgeBase.faqs' | translate }} ({{ kbaFaqCount }})</li>
                  <li class="kba_header" [ngClass]="(knowledgebasefilterinfo != null && knowledgebasefilterinfo.kbaType === KBA_TYPE_SOLUTION) ? 'kba-header-active' : ''" (click)="onChangeKbaType('solution')"> {{ 'KnowledgeBase.solution' | translate }} ({{ kbaSolutionCount }}) </li>     
                  <li class="calendar" id="date_time_picker">
                      <div id="reportranged">
                          <em class="fa fa-calendar"></em>&nbsp;
                          <span></span> 
                          <em class="fa fa-caret-down"></em>
                      </div>
                  </li>
                </ul>

                <!-- For Mobile changing the Layout to Drop-Down -->
                <!-- This will not be visible in Desktop View -->
                <div>
                    <div class="kba-dropdown d-lg-none">
                            <select class="form-control custom-select" id="kba_option_list"  (change)="onChangeKbaType($event.target.value)">
                                <option value="all"  [attr.selected] ="(knowledgebasefilterinfo === null || !knowledgebasefilterinfo.kbaType || knowledgebasefilterinfo.kbaType === null) ? true : null"> {{ 'KnowledgeBase.all' | translate }}  ({{ kbaResultsCount }}) </option>
                                <option value="article" [attr.selected] ="(knowledgebasefilterinfo != null && knowledgebasefilterinfo.kbaType === KBA_TYPE_ARTICLE) ? true : null"> {{ 'KnowledgeBase.article' | translate }} ({{ kbaArticleCount }})</option>
                                <option value="faqs" [attr.selected] ="(knowledgebasefilterinfo != null && knowledgebasefilterinfo.kbaType === KBA_TYPE_FAQ) ? true : null">{{ 'KnowledgeBase.faqs' | translate }} ({{ kbaFaqCount }})</option>
                                <option value="solution" [attr.selected] ="(knowledgebasefilterinfo != null && knowledgebasefilterinfo.kbaType === KBA_TYPE_SOLUTION) ? true : null">{{ 'KnowledgeBase.solution' | translate }} ({{ kbaSolutionCount }}) </option>
                            </select>
                            <div id="date_time_picker">
                              <div id="reportrangem">
                                  <em class="fa fa-calendar"></em>&nbsp;
                                  <span class="d-none"></span> 
                                  <em class="fa fa-caret-down"></em>
                              </div>
                            </div>
                    </div>
                </div>
                <!-- Closing Div for the Mobile Drop Down -->
              </div>
            
            </div>
          </div>
        </div>
        <!-- To display the kba list-->
        <div id="kba_container">
              <table class="" id="c_kba_table">
                <!-- <thead> -->
                <tr id="c_kba_table_header" class="cust-table-header">
                
                    <th  (click)="sort('kbaId')" style="flex: 0 0 100px;" id="kbaId">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'kbaId' && isDesc), 'fas fa-sort-up': (column == 'kbaId' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'KnowledgeBase.kbiId' | translate }}
                    </th>
                    <th (click)="sort('title')" style="flex: 0 0 100px; width: 30%;" id="title">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'title' && isDesc), 'fas fa-sort-up': (column == 'title' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'KnowledgeBase.title' | translate }}
                    </th>
                    <th (click)="sort('classification')" style="flex: 0 0 100px;" id="classification">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'classification' && isDesc), 'fas fa-sort-up': (column == 'classification' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'KnowledgeBase.classification' | translate }}
                    </th>
                    <th (click)="sort('created')" style="flex: 0 0 100px;" id="created">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'created' && isDesc), 'fas fa-sort-up': (column == 'created' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'KnowledgeBase.createdDate' | translate }}
                    </th>
                    <th (click)="sort('viewCount')" style="flex: 0 0 100px;" id="views">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'viewCount' && isDesc), 'fas fa-sort-up': (column == 'viewCount' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'KnowledgeBase.views' | translate }}
                    </th>
                    <th (click)="sort('averageRating')" style="flex: 0 0 100px;" id="rating">
                      <em class="fa fa-sort"
                          [ngClass]="{'fas fa-sort-down': (column == 'averageRating' && isDesc), 'fas fa-sort-up': (column == 'averageRating' && !isDesc) }"
                          aria-hidden="true">
                      </em>
                      {{ 'KnowledgeBase.rating' | translate }}
                    </th>
                    <th *ngIf="kbaCommentEnabledForCustomer" style="flex: 0 0 100px;" id="comments">
                      {{ 'KnowledgeBase.comments' | translate }}
                    </th>
                </tr>
                <tbody *ngIf="isKbalist" appInfinteScroll (scrolledEnd)="scrollEnd()" (scrolledCur)="scrollCur()"> 
                <tr class="table-body" *ngFor="let kba of kbaBasicInfoResponse; let i=index;trackBy: trackByItems "
                 routerLink='kba/{{ kba.kbaId }}' (click)='increaseViewCount(kba.kbaId)' id="c_kba_table_body">
                  <td>{{ kba.kbaId }}</td>
                  <td  *ngIf="kba.title.length<120; else elseBlock" >{{ kba.title }}</td>
                  <ng-template #elseBlock>
                      <td data-toggle="tooltip" data-placement="left"
                      title="{{kba.title}}">{{ kba.title.slice(0,119)+'...' }}  </td>
                  </ng-template>
                  <td>{{ kba.classification.classificationName }}</td>
                  <td>{{ kba.createdDate }}</td>
                  <td><span><em class="fa fa-eye"></em></span> &nbsp; {{ kba.viewCount }}</td>
                  <td>
                    <div [attr.id]="'rateYo' + i"></div>
                  </td>
                  <td *ngIf="kbaCommentEnabledForCustomer">{{ kba.numberOfComments }}</td>
                </tr>
                </tbody>
                <tbody *ngIf="kbaBasicInfoResponse?.length == 0  && !isLoading && !spinnerStart">
                  <tr  class="norecords">
                    <td colspan="6" class="text-center">{{ 'CommonStrings.noRecords' | translate }}</td>
                  </tr>
                </tbody>
            </table>
        </div>
      </div>
    </div>
    <!-- Spinner -->
    <div class="text-center col-12" id="sd_kba_item_loading ">
      <div *ngIf="isLoading || spinnerStart" id="spinner" role="progressbar">
          <zsd-spinner></zsd-spinner>
      </div>
  </div>
</div>
   <!-- End of On Scroll Load Div -->
   <div *ngIf="(scrollEndReached && kbaBasicInfoResponse?.length > 20) " class="text-center">
    <div class="card">
        <div class="card-body" id="c_no_kba_message">
            {{ 'CommonStrings.endOfScroll' | translate }}
        </div>
    </div>
</div>
